
<template>
  <div class="layout">
    <Layout>
      <yn-header></yn-header>
      <Layout>
        <Sider>
          <yn-slider></yn-slider>
        </Sider>
        <Layout :style="{paddingLeft: '20px'}">
          <yn-tags></yn-tags>
          <Content :style="{padding: '10px 20px', minHeight: '280px'}">
             <router-view/>
          </Content>
        </Layout>
      </Layout>
    </Layout>
  </div>
</template>
<script>
import YnHeader from "./YnHeader.vue";
import YnSlider from "./YnSlider.vue";
import YnTags from "./YnTags.vue";

export default {
  data() {
    return {
      name:"test"
    }
  },
  components: { YnHeader, YnSlider, YnTags },
  mounted() {
    // console.log(YnHeader);
   
  },
  methods: {
    
  }
};
</script>

<style scoped>
.layout {
  background: #f5f7f9;
  position: relative;
  overflow: hidden;
  height: 100%;
}

.ivu-layout-sider {
  background-color: #fff;
  overflow-y: scroll;
  padding: 10px;
}
.ivu-menu-light.ivu-menu-vertical .ivu-menu-item-active:not(.ivu-menu-submenu) {
  background-color: #f2f2f2;
}

.ivu-layout-content>div:first-child{
  /* margin-bottom: 10px; */
  /* padding-top: 12px; */
  height: 100%;
  overflow: hidden;
}
.layout>.ivu-layout>.ivu-layout-has-sider>
.ivu-layout>div:first-child{
  padding: 10px 20px;
    margin-bottom: 10px;
}
.ivu-menu-light.ivu-menu-vertical .ivu-menu-item-active:not(.ivu-menu-submenu):after {
    content: '';
    display: block;
    width: 2px;
    position: absolute;
    top: 0;
    bottom: 0;
    right: 0;
    background: #fff;
}
.ivu-menu-light.ivu-menu-vertical .ivu-menu-item-active:not(.ivu-menu-submenu) {
    color: #1955A8;
    background: #f1f2f6;
    z-index: 2;
}
.ivu-layout-sider /deep/ .ivu-layout-sider-children{
  border: 1px solid #f1f2f6;
}

</style>


// WEBPACK FOOTER //
// src/views/index/Index.vue